import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiLeasingOffersDetails } from 'modules/api';

export const fetchLeasingOffersDetails = createAsyncThunk(
  'leasingOffers/fetchLeasingOffersDetails',
  async (params: { id: number }, { rejectWithValue }) => {
    try {
      const response = await ApiLeasingOffersDetails.getLeasingOffersDetails(
        params,
      );
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
